import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { DateObject } from "react-multi-date-picker";
import ct from '../../../pages/Features/CapacityTracker/capacityTracker.module.css';
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";

export const useCapacity = () => {
    const [loader, setLoader] = useState(true);
    const [callApi, setCallApi] = useState(false);
    const [leadDropdown, setLeadDropdown] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [projectDropdown, setProjectDropdown] = useState([]);
    const [userDropdown, setUserDropdown] = useState([]);
    const [projectLeadSelected, setProjectLeadSelected] = useState([]);
    const [projectSelected, setProjectSelected] = useState([]);
    const [userSelected, setUserSelected] = useState([]);
    const [enteredWorkingHours, setEnteredWorkingHours] = useState("");
    const [hoveredRange, setHoveredRange] = useState([
        new DateObject().subtract(7, 'days'),
        new DateObject().add(7, 'days'),
    ]);
    const [upsertHoveredRange, setUpsertHoveredRange] = useState([
        new DateObject().subtract(8, 'days'),
        new DateObject().add(0, 'days'),
    ]);
    const [isEdit, setIsEdit] = useState(false);
    const { showSuccess, showInfo } = useContext(ToastContext);
    const [rowData, setRowData] = useState([]);
    const [apiMount, setApiMount] = useState(false)
    const [coldef, setColDefs] = useState([
        {
            field: "image_url",
            headerName: "",
            width: 42,
            pinned: "left",
            cellRenderer: (params) => {
                return (
                    <div>
                        <img src={params.data.image_url} style={{ borderRadius: "50%", height: '24px', width: '24px' }} alt="" />
                    </div>
                )
            }
        },
        {
            field: "user_display_name",
            headerName: "",
            width: 200,
            pinned: "left",
            className: 'text-left',
            cellStyle: { textAlign: 'left' },

        },
        {
            field: "today_worked",
            headerName: "Today worked",
            width: 90,
            pinned: "left",
            cellStyle: { textAlign: 'center' },
            cellRenderer: (params) => {
                return (
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        {params.data.today_worked?.total_work_hours ? `${params.data.today_worked?.total_work_hours}h` : "-"}
                    </div>
                )
            }
        },
        {
            field: "working_on",
            headerName: "Working on",
            width: 90,
            pinned: "left",
            cellStyle: { textAlign: 'center' },
            cellRenderer: (params) => {
                return (
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        {`${params.data.working_on?.issue_key ? params.data.working_on?.issue_key : ""}\n${params.data.working_on?.active_work_hours ? `( ${params.data.working_on.active_work_hours}h )` : ""}`}
                    </div>
                )
            }
        },
    ]);
    const [initialColdef] = useState([
        {
            field: "image_url",
            headerName: "",
            width: 60,
            pinned: "left",
            className: 'text-left',
            cellRenderer: (params) => {
                return (
                    <div>
                        <img src={params.data.image_url} style={{ borderRadius: "50%", height: '24px', width: '24px' }} alt="" />
                    </div>
                )
            }
        },
        {
            field: "user_display_name",
            headerName: "",
            width: 200,
            pinned: "left",
            className: 'text-left',
            cellStyle: { textAlign: 'left' },
        },
        {
            field: "today_worked",
            headerName: "Today worked",
            width: 90,
            pinned: "left",
            cellStyle: { textAlign: 'center' },
            cellRenderer: (params) => {
                return (
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        {params.data.today_worked?.total_work_hours ? `${params.data.today_worked?.total_work_hours}h` : "-"}
                    </div>
                )
            }
        },
        {
            field: "working_on",
            headerName: "Working on",
            width: 90,
            pinned: "left",
            cellStyle: { textAlign: 'center' },
            cellRenderer: (params) => {
                return (
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        {`${params.data.working_on?.issue_key ? params.data.working_on?.issue_key : ""}\n${params.data.working_on?.active_work_hours ? `( ${params.data.working_on.active_work_hours}h )` : ""}`}
                    </div>
                )
            }
        },
    ]);

    useEffect(() => {
        callautopopulate("project_leads", "user_info", "projects").then(res => {
            const data = _.filter(res?.project_leads, { user_code: res?.user_info[0]?.user_code });
            setProjectLeadSelected(data)
            setApiMount(true)
            setLeadDropdown(res.project_leads)
            setProjectDropdown(res?.projects?.sort((a, b) => a.project_name.localeCompare(b.project_name)))
        }).catch((error) => {
            setApiMount(true)
        });
    }, []);

    useEffect(() => {
        if (hoveredRange && hoveredRange[0] !== undefined && hoveredRange[1] !== undefined && apiMount) {
            getCapacityTracker();
        }
        // eslint-disable-next-line
    }, [isEdit, hoveredRange, callApi, apiMount]);

    useEffect(() => {
        setUpsertHoveredRange(hoveredRange);
    }, [hoveredRange])

    // get capacity tracker data
    const getCapacityTracker = async () => {
        setLoader(true);
        try {
            let formatData = [];
            let arr = [...initialColdef];

            const payload = {
                from_date: hoveredRange[0]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-"),
                to_date: hoveredRange[1]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-"),
                projects: _.pluck(projectSelected, 'project_id').toString(),
                project_lead_user_code: _.pluck(projectLeadSelected, 'user_code').toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETCAPACITYTRACKER"), payload);
            const CapacityData = res?.body?.data?.capacity_tracker;
            const activeHoursData = res?.body?.data?.active_work_hours;
            const totalHoursData = res?.body?.data?.total_work_hours;

            // generate dynamic columns date wise 
            const allDates = _.uniq(_.pluck(CapacityData, "day_date"));
            allDates?.forEach((data) => {

                const date = data.split("T")[0];
                const headerDate = new Date(data)
                const dayHeader = headerDate.toLocaleDateString('en-US', { day: 'numeric' });
                const monthHeader = headerDate.toLocaleDateString('en-US', { month: 'short' });
                const weekDay = headerDate.toString().slice(0, 3);
                const formattedMonth = monthHeader.length > 3 ? monthHeader.slice(0, 3) : monthHeader;

                let obj = {
                    field: date,
                    headerName: `${formattedMonth}\n${dayHeader}\n${weekDay}`,
                    width: 50,
                    headerClass: `header-wrap ${weekDay === "Sun" ? "sunday" : ""}`,
                    cellRenderer: (params) => {
                        let classname;
                        if (params.data[date]?.percentage > 100) {
                            classname = "ct-red";
                        } else if (params.data[date]?.percentage >= 70 && params.data[date]?.percentage <= 100) {
                            classname = "ct-green";
                        } else if (params.data[date]?.percentage >= 30 && params.data[date]?.percentage < 70) {
                            classname = "ct-blue";
                        } else if (params.data[date]?.percentage > 0 && params.data[date]?.percentage <= 30) {
                            classname = "ct-yellow";
                        } else if (params.data[date]?.capacity_hours == null) {
                            classname = " ";
                        }
                        if (weekDay === "Sun") {
                            classname = "timesheet-holiday-cell";
                        }

                        return (
                            <div className={ct["ct-each-cell"]}>
                                {!isEdit ? (
                                    <div className={ct[classname]}>{params.data[date].percentage}{params.data[date].percentage ? "%" : ""}</div>
                                ) : (
                                    <div style={{ height: "100%" }}>
                                        {weekDay !== "Sun" ? (
                                            <input type='Number' defaultValue={params.data[date]?.capacity_hours} onBlur={(e) => UpsertCapacityTracker(e, params, false)} />
                                        ) : (
                                            <div className="timesheet-holiday-cell">{""}</div>
                                        )}

                                    </div>
                                )}
                            </div>
                        )
                    }
                }

                if (_.isEmpty(_.findWhere(arr, { field: date }))) {
                    arr.push(obj);
                } else {
                    const index = _.indexOf(arr, _.findWhere(arr, { field: date }));
                    if (index !== -1) {
                        arr[index].cellRenderer = obj.cellRenderer;
                    }
                }
            })
            setColDefs(_.uniq(arr));

            // set row data for each user date wise
            const usercodes = _.uniq(_.pluck(CapacityData, "user_code"));
            usercodes.forEach((code) => {
                if (code !== null) {
                    const data = _.filter(CapacityData, { user_code: code });
                    const workingOn = _.find(activeHoursData, { user_code: code });
                    const totHours = _.find(totalHoursData, { user_code: code });
                    let obj = {
                        user_code: code,
                        user_display_name: data?.[0]?.user_display_name,
                        image_url: data?.[0]?.image_url,
                    };
                    data.forEach((item) => {
                        let itemDate = item.day_date?.split("T")?.[0];
                        obj[itemDate] = {
                            capacity_hours: item.workhours,
                            tracker_id: item.tracker_id === null ? 0 : item.tracker_id,
                        };
                        if (item?.estimate_hours !== null && item?.workhours !== null) {
                            obj[itemDate].percentage = parseInt((item?.estimate_hours / item?.workhours) * 100);
                        } else {
                            obj[itemDate].percentage = "";
                        }
                    })

                    allDates?.forEach((date) => {
                        const findData = _.findWhere(CapacityData, { day_date: date })

                        if (obj[date?.split("T")?.[0]] === undefined) {
                            obj[date?.split("T")?.[0]] = {
                                capacity_hours: 8,
                                tracker_id: 0,
                                percentage: ""
                            }
                        }

                        if (findData?.workhours === null) {
                            obj[date?.split("T")?.[0]].capacity_hours = null;
                        }
                    })
                    obj["working_on"] = workingOn ? workingOn : {}
                    obj["today_worked"] = totHours ? totHours : {}

                    if (_.isEmpty(_.find(formatData, { user_code: code }))) {
                        formatData.push(obj);
                    }
                }
            })
            setRowData(_.sortBy(formatData, "user_display_name"));

            // set user dropdown values
            const username = _.uniq(_.pluck(formatData, "user_display_name"));
            let userData = [];
            username?.forEach((name) => {
                const obj = {
                    user_display_name: name,
                    user_code: _.findWhere(formatData, { user_display_name: name })?.user_code
                }
                userData.push(obj)
            })
            setUserDropdown(_.sortBy(userData, "user_display_name"));
            setLoader(false);
        } catch (error) {
            console.error("Error getting capacity tracker data: ", error);
            setLoader(false);
        }
    }

    // save working hours of user date wise
    const UpsertCapacityTracker = async (event, rowdata, multi) => {
        try {
            let tvpArr = [];
            if (!multi) {
                if (event.target.value === "") {
                    showInfo("info", "Working hours cannot be empty");
                    return;
                }
                tvpArr = [{
                    "tracker_id": rowdata.data[rowdata.colDef.field].tracker_id,
                    "working_hours": event.target.value,
                    "from_date": rowdata.colDef.field,
                    "user_code": rowdata.data.user_code
                }]
            } else {
                if (_.isEmpty(userSelected)) {
                    showInfo("info", "Please select users");
                    return;
                } else if (enteredWorkingHours?.length === 0) {
                    showInfo("info", "Please enter working hours");
                    return;
                }
                const upsertFrom = upsertHoveredRange[0]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-")
                const upsertTo = upsertHoveredRange[1]?.toDate().toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-")
                userSelected?.forEach((user) => {
                    const data = _.findWhere(rowData, { user_code: user?.user_code });
                    Object.keys(data)?.forEach((key) => {
                        if (key !== "image_url" && key !== "today_worked" && key !== "user_code" && key !== "user_display_name" && key !== "working_on" && key >= upsertFrom && key <= upsertTo) {
                            const obj = {
                                user_code: user?.user_code,
                                working_hours: enteredWorkingHours,
                            }
                            obj.from_date = key;
                            obj.tracker_id = data[key]?.tracker_id;
                            tvpArr.push(obj);
                        }
                    })
                })
            }

            const payload = {
                "tvp_user_capacity_insert": tvpArr
            }

            const res = await services.getInvokeRemote("POST", Urls("UPSERTCAPACITYTRACKER"), payload);
            if (res) {
                showSuccess("success", res.body.message);
                getCapacityTracker();
                setUserSelected([]);
                setEnteredWorkingHours("");
            }

        } catch (error) {
            console.error("Error getting capacity tracker data: ", error);
        }
    }

    // show edit view
    const handleEdit = () => {
        setIsEdit(!isEdit);
        setUserSelected([]);
        setEnteredWorkingHours("");
    }

    return useMemo(() => ({
        leadDropdown, projectLeadSelected, setProjectLeadSelected, projectDropdown, projectSelected, setProjectSelected, hoveredRange, setHoveredRange, upsertHoveredRange, setUpsertHoveredRange, isEdit, userDropdown, userSelected, setUserSelected, enteredWorkingHours, setEnteredWorkingHours, coldef, rowData, handleEdit, UpsertCapacityTracker, loader, callApi, setCallApi, isChanged, setIsChanged
    }), [leadDropdown, projectLeadSelected, setProjectLeadSelected, projectDropdown, projectSelected, setProjectSelected, hoveredRange, setHoveredRange, upsertHoveredRange, setUpsertHoveredRange, isEdit, userDropdown, userSelected, setUserSelected, enteredWorkingHours, setEnteredWorkingHours, coldef, rowData, handleEdit, UpsertCapacityTracker, loader, callApi, setCallApi, isChanged, setIsChanged])
}